<dl class="c-detail__list">
  <dt class="c-detail__list-title">Address</dt>
  <dd class="c-detail__list-description">{{Address}}</dd>
  <dt class="c-detail__list-title">Time at address</dt>
  <dd class="c-detail__list-description">{{TimeAtAddress}}</dd>
</dl>

@if (NeedsAddressMatch && !addressMatchDoneAlready) {
  <fieldset class="form-group">
    <div class="alert alert-danger d-inline-flex p-0 mw-50">
      <div class="mr-1 pt-1">
        <i class="material-icons">error</i>
      </div>
      <div>We've found more than one address. Please choose the right one</div>
    </div>
    <div class="c-radio--scrollbox custom-controls-stacked">
      @for (match of address.AddressMatches; track match) {
        <span class="c-radio-button">
          <label class="custom-control custom-radio">
            <input id="{{applicantIterator}}-{{iterator}}-address-match-{{match['PtcAbsCode']}}" name="{{applicantIterator}}-{{iterator}}-address-match" type="radio" class="custom-control-input" (click)="setPtcAbsCode(match['PtcAbsCode'])">
            <span class="custom-control-indicator"></span>
            <span class="custom-control-description">{{formatMatchAddress(match)}}</span>
          </label>
        </span>
      }
    </div>
  </fieldset>
}